import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from '@/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker with error handling and update callback
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register((registration) => {
    // Dispatch custom event when update is available
    const event = new CustomEvent('sw-update', {
      detail: { registration }
    });
    window.dispatchEvent(event);
  });
} else {
  // In development, unregister any existing service workers to prevent conflicts
  serviceWorkerRegistration.unregister();
}
